import { i18n, registerI18nBundle } from '@cyberint/common-utils';
import resources from './resources';

const NAMESPACE = 'statefulUi';

registerI18nBundle({
  namespace: NAMESPACE,
  en: resources,
  loaders: {
    es: () => import(/* webpackChunkName: "stateful-ui-i18n-locale-es" */ './locales/es'),
    fil: () => import(/* webpackChunkName: "stateful-ui-i18n-locale-fil" */ './locales/fil'),
    ja: () => import(/* webpackChunkName: "stateful-ui-i18n-locale-ja" */ './locales/ja'),
    th: () => import(/* webpackChunkName: "stateful-ui-i18n-locale-th" */ './locales/th')
  }
});

export const statefulUiT = i18n.getFixedT(null, null, NAMESPACE);
export const t = statefulUiT;
